import React from "react";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { ApiResponse } from "../../../services/api";
import EmailLog from "../../../types/emailLog";

interface EmailLogTableProps {
  rows: EmailLog[];
  columns: GridColDef[];
  apiResponse: ApiResponse<EmailLog> | null;
  paginationModel: any;
  setPaginationModel: any;
}

/**
 * Grid dos e-mails enviados. Sem ordenacao por coluna de proposito: e um log,
 * sempre listado do mais recente para o mais antigo (ver EmailLogDAO.FindByFilter) -
 * uma coluna clicavel que na pratica nao muda nada so confundiria.
 */
const EmailLogTable: React.FC<EmailLogTableProps> = ({
  rows,
  columns,
  apiResponse,
  paginationModel,
  setPaginationModel,
}) => {
  return (
    <div style={{ height: '100%', width: '100%', display: 'flex', flexDirection: 'column' }}>
      <div style={{ flex: 1, minHeight: 0 }}>
        <DataGrid
          rows={rows}
          columns={columns}
          getRowId={(row) => row.id}
          rowHeight={36}
          columnHeaderHeight={40}
          pageSizeOptions={[10, 20, 40, 100]}
          pagination
          paginationMode="server"
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          rowCount={apiResponse?.data?.totalItems ?? 0}
          checkboxSelection={false}
          disableRowSelectionOnClick
          getRowClassName={(params) =>
            params.row.sucesso ? '' : 'email-log-falha'
          }
          sx={{
            '& .MuiDataGrid-row:nth-of-type(even)': {
              backgroundColor: '#f5f5f5',
            },
            '& .MuiDataGrid-row:nth-of-type(odd)': {
              backgroundColor: 'white',
            },
            '& .MuiDataGrid-row:hover': {
              backgroundColor: '#b2d1ff',
            },
            '& .email-log-falha': {
              backgroundColor: '#fdecea !important',
            },
            '& .MuiTablePagination-selectLabel': {
              marginTop: '14px',
            },
            '& .MuiTablePagination-displayedRows': {
              marginTop: '14px',
            },
            '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
              outline: 'none',
            },
            '& .MuiDataGrid-row:focus, & .MuiDataGrid-row:focus-within': {
              outline: 'none',
            },
          }}
        />
      </div>
    </div>
  );
};

export default EmailLogTable;
